import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import sanitizeText from '../../utils/sanitize-lang-text';

function EmptyOption(props) {
  return (
    <option value="" disabled>
      {sanitizeText(props.placeholderMessage)}
    </option>
  );
}

EmptyOption.propTypes = {
  placeholderMessage: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const keyToUse = ownProps.translationKey ? ownProps.translationKey : 'address.pleaseSelect'; // If no key defined, set to default
  
  return {
    placeholderMessage: state.lang[keyToUse],
  };
};

export default connect(
  mapStateToProps,
)(EmptyOption);
